// Site-wide details shown on the landing and legal pages. Razorpay reviews these
// pages before activating payments, so fill in your real business details.
export const SITE = {
  name: 'CodeReviser',
  // TODO: replace with your support address and registered business details.
  supportEmail: 'support@example.com',
  businessName: 'CodeReviser',
  businessAddress: 'Your registered business address',
  // Set REACT_APP_CHROME_STORE_URL once the extension is published.
  chromeStoreUrl: process.env.REACT_APP_CHROME_STORE_URL || '',
  extensionZip: '/downloads/codereviser-extension.zip',
};
